import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome';

import NavigationItems from './Navigation/NavigationItems.js';

const Footer = (props) => {

	const {
		allLocations,
		locationId,
		pageList
	} = props

	// eslint-disable-next-line
	const locationList = pageList.filter(x => x.component == 'Home');
	let facebookUrl = 'https://www.facebook.com/afterschoolmusicpitman';

	if(locationId != null) {
		// eslint-disable-next-line
		const locationPages = pageList.filter(x => x.locationId == locationId && (x.component == 'PrivacyPolicy' || x.component == 'ContactUs'));
		locationList.push(...locationPages);
		if(allLocations && allLocations.length > 0) {
			// eslint-disable-next-line
			const matchingLocation = allLocations.filter(x => x.id == locationId);
			if(matchingLocation && matchingLocation.length === 1) {
				if (matchingLocation[0].hasOwnProperty('FacebookUrl')) {
					facebookUrl = matchingLocation[0].FacebookUrl
				}
			}
		}
	}

	return (
		<footer>
			<div className='content'>
				<div className='socialMediaLinks'>
					<a href={facebookUrl} target='_blank' rel='noreferrer'><FontAwesomeIcon icon={['fab', 'facebook-square']} color='#FFFFFF' /></a>
					{/* <a href='https://www.facebook.com/afterschoolmusicpitman' target='_blank'><FontAwesomeIcon icon={['fab', 'facebook-square']} color='#3B5998' /></a> */}
					{/* <FontAwesomeIcon icon={['fab', 'twitter-square']} color='#55ACEE'/> */}
					{/* <FontAwesomeIcon icon={['fab', 'youtube']} color='#E52D27' /> */}
					{/* <FontAwesomeIcon icon={['fab', 'instagram']} color='#517fA4' /> */}
				</div>
				<div className='navigation'>
					<NavigationItems list={locationList} />
				</div>
			</div>
		</footer>
	);
};

const mapStateToProps = state => {
	return {
		allLocations: state.application.locations,
		pageList: state.application.pages
	};
};

export default connect(mapStateToProps, null)(Footer);
